import Spinner from "components/Spinner";
import React from "react";

const GallerySpinner = () => {
  return (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <Spinner />
    </div>
  );
};

export default GallerySpinner;
